export const countDecimals = value => {
  if (value === null || value === undefined) {
    return 0;
  }

  if (!isNaN(value) && Math.floor(value) !== value) {
    const splitValue = value.toString().split('.');
    if (splitValue[1] !== undefined) {
      return splitValue[1].length || 0;
    }
  }

  return 0;
};

export const maxDecimalPointsValidator = (maxDecimalPoints, message) => ({
  validator: (rule, value, callback) => {
    if (countDecimals(value) > maxDecimalPoints) {
      return callback(message);
    }
    callback();
  },
});

export const mustBeGreaterThanValidator = (minValue, message) => ({
  validator: (rule, value, callback) => {
    if (value <= minValue) {
      return callback(message);
    }
    callback();
  },
});

export default {};
